import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api, errorMessage, formatDate } from "@/lib/api";
import { TAB_LIST, TAB_TRIGGER } from "@/lib/tabStyles";
import { AnswersByStep } from "@/components/assessment/ScoreSummary";
import { ScoreChart } from "@/components/assessment/HistorySection";
import { Notice } from "@/components/form/FormFeedback";
import { Loading } from "@/components/layout/RequireAuth";
import { Growth } from "@/lib/growth";

const label = (s, i) => `${i === 0 ? "Ultimo · " : ""}${formatDate(s.submitted_at)} — ${s.score_total} ${s.level}`;

const SubmissionPanel = ({ sub, prev }) => (
    <div data-testid="submission-panel">
        <p className="text-lg" data-testid="submission-panel-score">
            Assessment del {formatDate(sub.submitted_at)}: punteggio <strong>{sub.score_total}/100</strong> · livello <strong>{sub.level}</strong>
        </p>
        {prev && <p className="mt-1" data-testid="submission-panel-growth"><Growth current={sub.score_total} reference={prev.score_total} suffix="rispetto al precedente" /></p>}
        <ul className="mt-2 grid gap-x-6 gap-y-1 sm:grid-cols-2" data-testid="submission-panel-areas">
            {sub.area_scores.map((a) => <li key={a.key}>{a.label}: <strong>{a.score}/100</strong></li>)}
        </ul>
        <h4 className="mt-5 mb-3 text-lg font-bold">Le risposte</h4>
        <AnswersByStep view={sub.answers_view} />
    </div>
);

export const SubmissionTabs = ({ items, latest }) => {
    const [tab, setTab] = useState(items[0].id);
    const [details, setDetails] = useState({ [latest.id]: latest });
    const [error, setError] = useState("");
    const select = async (value) => {
        setTab(value);
        setError("");
        if (value === "andamento" || details[value]) return;
        try {
            const { data } = await api.get(`/companies/me/assessments/${value}`);
            setDetails((d) => ({ ...d, [value]: data }));
        } catch (e) {
            setError(errorMessage(e));
        }
    };
    return (
        <section aria-labelledby="answers-title" className="edi-card p-5 sm:p-6" data-testid="latest-answers">
            <h3 id="answers-title" className="text-xl font-bold">Le tue risposte e lo storico</h3>
            <Tabs value={tab} onValueChange={select} className="mt-4">
                <div className="overflow-x-auto" data-testid="submission-tabs-scroll">
                    <TabsList className={`${TAB_LIST} flex-nowrap min-w-max`} aria-label="Assessment compilati">
                        {items.map((s, i) => (
                            <TabsTrigger key={s.id} value={s.id} className={`${TAB_TRIGGER} whitespace-nowrap`} data-testid={`submission-tab-${i}`}>{label(s, i)}</TabsTrigger>
                        ))}
                        {items.length >= 2 && <TabsTrigger value="andamento" className={`${TAB_TRIGGER} whitespace-nowrap`} data-testid="submission-tab-andamento">Andamento nel tempo</TabsTrigger>}
                    </TabsList>
                </div>
                {items.map((s, i) => (
                    <TabsContent key={s.id} value={s.id} className="mt-5 focus-visible:ring-0">
                        {details[s.id] ? <SubmissionPanel sub={details[s.id]} prev={items[i + 1]} /> : !error && <Loading />}
                    </TabsContent>
                ))}
                {items.length >= 2 && (
                    <TabsContent value="andamento" className="mt-5 focus-visible:ring-0" data-testid="submission-trend">
                        <ScoreChart items={items} />
                    </TabsContent>
                )}
            </Tabs>
            {error && <Notice kind="error" role="alert">{error}</Notice>}
        </section>
    );
};
